<template>
  <span>
    <svg
      width="293"
      height="296"
      viewBox="0 0 293 296"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.9296e-06 16.3709C4.9296e-06 11.8285 1.66731 7.68588 4.58517 4.74242C6.09649 3.22987 7.89146 2.03213 9.86661 1.21823C11.8418 0.404327 13.9581 -0.00965471 16.0935 0.000170886H170.124C208.4 0.000170886 239.174 10.3205 260.287 29.2531C281.419 48.1675 293 75.767 293 110.071C293 128.241 289.249 144.448 282.307 158.329C275.428 172.113 265.285 183.997 252.766 192.942L290.97 281.609C291.665 283.168 291.952 284.877 291.807 286.578C291.661 288.278 291.086 289.913 290.137 291.33C289.216 292.77 287.948 293.953 286.449 294.77C284.95 295.586 283.27 296.009 281.564 295.999H190.73C187.934 296.024 185.199 295.18 182.901 293.583C180.612 291.996 178.836 289.773 177.79 287.187L148.013 213.147H103.647V281.9C103.646 285.606 102.179 289.16 99.5696 291.784C96.9535 294.39 93.4162 295.852 89.7287 295.854H13.9187C10.2249 295.857 6.68023 294.394 4.05962 291.784C1.45649 289.157 -0.00309559 285.603 4.9296e-06 281.9V16.3709ZM103.792 84.8154V136.38H155.226C164.324 136.38 171.628 134.127 176.666 129.839C181.705 125.533 184.477 119.192 184.477 111.125C184.477 102.531 181.705 95.9715 176.666 91.52C171.628 87.0866 164.342 84.8154 155.226 84.8154H103.792Z"
        fill="#00FFE0"
      />
    </svg>
  </span>
</template>
<script setup lang="ts"></script>
<style scoped lang="postcss">
span {
  display: inline-block;
  > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
